import * as React from 'react';

/**
 * SOLO para Storybook — permite que un Sheet (Portal de Radix) se monte
 * DENTRO de un marco de móvil acotado (`PhoneFrame`, ver MobileNav.stories.tsx)
 * en vez de al final de `<body>`, que es donde va por defecto. Sin esto, el
 * Sheet real usa `position: fixed` anclado al viewport del navegador — en
 * producción eso es correcto (el viewport real ES la pantalla del móvil),
 * pero dentro de un marco de 390×844 en medio de una página de Storybook más
 * grande, el Sheet salía a pantalla completa del navegador, no del marco.
 *
 * El mecanismo real que lo arregla: `position: fixed` se ancla al ancestro
 * con `transform` más cercano en vez de al viewport (regla real de CSS, la
 * misma que ya usa `PhoneFrame` con `translateZ(0)` para que el bottom nav
 * se quede pegado al marco) — con el contenedor del Portal viviendo DENTRO
 * de ese marco transformado, el `fixed` de `ui/Sheet` hereda gratis el mismo
 * anclaje, sin tocar ni una clase de `sheet.tsx`.
 *
 * `undefined` por defecto: fuera de un `PhoneFrame`, cualquier componente que
 * use este contexto sigue portando a `document.body` como siempre (mismo
 * comportamiento que en producción real).
 */
export const MobileFrameContext = React.createContext<HTMLElement | undefined>(undefined);

export const useMobileFrameContainer = () => React.useContext(MobileFrameContext);
